export default [
  { 
    path: '/calendar', 
    name: 'Calendar', 
    component: () => import('@/views/calendar/Index'),
    meta: {
      breadcrumbs: [
        { text: 'ปฏิทิน', disabled: true }
      ]
    }
  },
]